define('gumbo-js-client-lib/forms/gameData/DateTeamForm',{
	ampm: null,
	time: null,
	timezone: null,
	league: {
		time: null,
		ampm: null,
		timeDate: null,
		timezone: null,
		timezoneGen: null
	}
});
